import { FeatureType, Menu, MenuType } from './menu-item-shared';

const actions: Menu = {
  state: 'actions',
  name: 'menu.maintenance.actions',
  icon: 'build',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.StationMaintenance],
};

const alerts: Menu = {
  state: 'alerts',
  name: 'menu.maintenance.alerts',
  icon: 'notifications_none',
  type: MenuType.Static,
  requiredFeatures: [FeatureType.StationMaintenance],
};

export const maintenanceMenu: Menu = {
  state: 'maintenance',
  name: 'menu.maintenance',
  type: MenuType.Expandable,
  icon: 'build',
  requiredFeatures: [FeatureType.StationMaintenance],
  children: [actions, alerts],
};
